import { makeStyles } from '@material-ui/core';
export const useStyles = makeStyles(theme => ({
  list: {
    width: 250
  }
}));